import { Splide } from "@splidejs/splide";
import { AutoScroll } from "@splidejs/splide-extension-auto-scroll";

export function slide() {
  document.addEventListener("DOMContentLoaded", function () {
    if (document.querySelector(".splide01")) {
      new Splide(".splide01", {
        type: "loop",
        perPage: 3,
        perMove: 1,
        autoplay: true,
        interval: 3000,
        pauseOnHover: false,
        focus: 0,
      }).mount();
    }

    if (document.querySelector(".splide02")) {
      new Splide(".splide02", {
        perPage: 3,
        type: "loop",
        focus: 0,
        autoScroll: { speed: 2 },
      }).mount({ AutoScroll });
    }

    if (
      document.querySelector(".splide04") &&
      document.querySelector(".splide05")
    ) {
      const splideTop = new Splide(".splide04", {
        autoplay: true,
        type: "loop",
        rewind: false,
        pauseOnHover: false,
        interval: 2000,
        speed: 1000,
        perPage: 3,
        focus: "center",
        updateOnMove: true,
        pagination: false,
        arrows: {
          prev: ".splide__arrow--prev",
          next: ".splide__arrow--next",
        },
        gap: 40,
        breakpoints: { 767: { perPage: 1 } },
      });

      const splideBottom = new Splide(".splide05", {
        autoplay: true,
        type: "loop",
        rewind: false,
        pauseOnHover: false,
        interval: 2000,
        speed: 1000,
        perPage: 4,
        updateOnMove: true,
        pagination: false,
        arrows: false,
        gap: 40,
        breakpoints: { 767: { gap: 8 } },
      });

      let isSyncing = false;

      function syncSlides(primary, secondary) {
        primary.on("move", function () {
          if (!isSyncing) {
            isSyncing = true;
            const primaryIndex =
              primary.index % secondary.Components.Elements.slides.length;
            secondary.go(primaryIndex, false);
          }
        });
        secondary.on("move", function () {
          if (!isSyncing) {
            isSyncing = true;
            const secondaryIndex =
              secondary.index % primary.Components.Elements.slides.length;
            primary.go(secondaryIndex, false);
          }
        });
        primary.on("moved", function () {
          isSyncing = false;
        });
        secondary.on("moved", function () {
          isSyncing = false;
        });
      }

      splideTop.mount();
      splideBottom.mount();
      syncSlides(splideTop, splideBottom);
      syncSlides(splideBottom, splideTop);
    }

    const mainEl = document.querySelector("#main-carousel");
    const thumbsEl =
      document.querySelector("#thumbnail-carousel") ||
      document.querySelector(".splide06");

    if (mainEl) {
      const main = new Splide(mainEl, {
        type: "fade",
        rewind: true,
        pagination: false,
        arrows: false,
        drag: true,
      });

      if (thumbsEl) {
        const thumbCount = thumbsEl.querySelectorAll(
          ".splide__list > .splide__slide"
        ).length;
        if (thumbCount > 0) {
          const thumbs = new Splide(thumbsEl, {
            type: thumbCount > 3 ? "loop" : "slide",
            rewind: false,
            perPage: 3,
            perMove: 1,
            pagination: false,
            arrows: false,
            gap: "16px",
            direction: "ttb",
            // height: "max(calc(480 / 1440 * 100vw), 480px)",
            height: "30rem",
            isNavigation: true,
            breakpoints: {
              767: {
                direction: "ltr",
                height: "inherit",
              },
            },
          });
          main.sync(thumbs);
          thumbs.mount();
        }
      }

      main.mount();
    }
  });
}
